import { KeyValueModel } from "../../model";
import { EnumModulo } from "../../model/enums/enum-modulo";

export const ModoAplicacaoMock: KeyValueModel[] = [
    new KeyValueModel(EnumModulo.KDS, "Monitor de Preparo"),
    new KeyValueModel(EnumModulo.EntregaLocal, "Entrega Local"),
    // new KeyValueModel(EnumModulo.EntregaDelivery, "Expedição Delivery"),
    new KeyValueModel(EnumModulo.Motoboy, "Painel do Entregador"),
];
